import { useEffect, useState } from "react";
import { getLocalStorage } from "../constants/localStorage";

export function useRole() {
  const [role, setRole] = useState(() => {
    const userData = getLocalStorage("adminUser");
    return userData?.role || "";
  });
  const [user, setUser] = useState(() => {
    const userData = getLocalStorage("adminUser");
    return userData || null;
  });

  useEffect(() => {
    const userData = getLocalStorage("adminUser");
    if (userData) {
      setRole(userData?.role);
      setUser(userData);
    }
  }, []);

  return { role, user };
}
